module.exports = __webpack_public_path__ + "img/reference.ab196bf2.png";